import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { sortingParamType, zonePropertiesType, zonesType } from '../../types';
import ZoneRow from './ZoneRow';
import SortControl from '../SortControl';
import './_styles_/ZonesList.css';

ZonesList.propTypes = {
    zones: zonesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
    zoneProps: zonePropertiesType.isRequired,
};

function ZonesList(props) {
    const {
        zones,
        onSort,
        sortingParam,
        zoneProps,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="zones-list">
            <div className="rich-list-row rich-list-header zones-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="zone-header--values--flag" />
                <div className="zone-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('zones.list-header.name')}
                    </SortControl>
                </div>
                <div className="zone-header--values--code">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="code">
                        {t('zones.list-header.code')}
                    </SortControl>
                </div>
                <div className="zone-header--values--clearing-house">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="clearingHouse.code">
                        {t('zones.list-header.clearing-house')}
                    </SortControl>
                </div>
                <div className="zone-header--values--currency">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="currency.code">
                        {t('zones.list-header.currency')}
                    </SortControl>
                </div>
                <div className="zone-header--values--active">
                    <SortControl sortingKey="active" sortingParam={sortingParam} onChange={onSort}>
                        {t('zones.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                zones.length
                    ? zones.map((zone) => <ZoneRow zone={zone} zoneProps={zoneProps} key={zone.id} />)
                    : (<div className="zones-no-items">{t('zones.no-items')}</div>)
            }
        </div>
    );
}

export default ZonesList;
